export default __webpack_public_path__ + "static/media/accounts.85ebb912.svg";